import { useEffect } from 'react';

import { useNotifications } from '@betterment/shared-components';
import Cookies from 'js-cookie';
import { useLocation } from 'react-router-dom';
import * as yup from 'yup';

const payloadSchema = yup.object().shape({
  _rails: yup.object().shape({
    exp: yup.string().nullable(),
    pur: yup.string().required(),
    message: yup.string().required(),
  }),
});

const toastSchema = yup.object().shape({
  success: yup.string(),
  error: yup.string(),
  warning: yup.string(),
});

export type Toast = yup.Asserts<typeof toastSchema>;

function parseToastCookie(cookie: string): Toast {
  const [data, _signature] = cookie.split('--', 2);
  const { _rails } = payloadSchema.validateSync(JSON.parse(atob(data)));
  return toastSchema.validateSync(JSON.parse(atob(_rails.message)));
}

export function readToastCookie(): Toast | null {
  const cookie = Cookies.get('toast');
  if (!cookie) return null;

  Cookies.remove('toast');

  try {
    return parseToastCookie(cookie);
  } catch (error) {
    if (error instanceof yup.ValidationError) {
      throw error;
    }

    return null;
  }
}

export function useToastCookie() {
  const location = useLocation();
  const { showNotification } = useNotifications();

  useEffect(() => {
    const toast = readToastCookie();
    if (toast?.success) showNotification('success', toast.success);
    if (toast?.error) showNotification('critical', toast.error);
    if (toast?.warning) showNotification('warning', toast.warning);
  }, [location, showNotification]);
}
